import { put, takeLatest , takeEvery } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from '../../../common/method/handleNotificationAlert'


export const actionTypes = {
    selectRecommendedProtfolio: "selectRecommendedProtfolio [Action]",
    selectRecommendedProtfolioMarket: "selectRecommendedProtfolioMarket [Action]",
    selectRecommendedProtfolioLoading: "selectRecommendedProtfolioLoading [Action]",
    selectRecommendedProtfolioAsync: "selectRecommendedProtfolioAsync [Action]",
    selectRecommendedProtfolioClear: "selectRecommendedProtfolioAsync [Action]",
};
const inistiaState = {
    data: [],
    market:[],
    loading: false,
    total:0
};

export const selectRecommendedProtfolioReducer = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.selectRecommendedProtfolio:
            return {
                ...state,
                data: payload?.results,
                total: payload?.total,
            };
        case actionTypes.selectRecommendedProtfolioMarket:
            return {
                ...state,
                market: payload?.results,
                total: payload?.total,
            };
        case actionTypes.selectRecommendedProtfolioLoading:
            return {
                ...state,
                loading: payload,
            };
        case actionTypes.selectRecommendedProtfolioClear:
            return {
                ...inistiaState,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectRecommendedProtfolioLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "portfolio",
        method_type: "select_recommended_portfolio",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }


        if (payload?.data?.portfolio_type === "industry") {
            yield put({ type: actionTypes.selectRecommendedProtfolio, payload: res?.data?.response?.data})
            return;
        }

        if (payload?.data?.portfolio_type === "market") {
            yield put({ type: actionTypes.selectRecommendedProtfolioMarket, payload: res?.data?.response?.data})
        }

        
        // yield put({ type: actionTypes.selectRecommendedProtfolio, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectRecommendedProtfolioLoading, payload: false })

    }
}

export function* selectRecommendedProtfolio() {
    yield takeEvery(actionTypes.selectRecommendedProtfolioAsync, handleWorker);
}
